import { SchemaDefinition } from './serializeFeedbackUIToLC';

export const schemaHasOneFeedbackProperty = (
  schema: SchemaDefinition | undefined
) => {
  return (
    schema?.properties &&
    Object.keys(schema.properties).filter((key) => key !== 'comment').length ===
      1
  );
};
